/**
 * StatusEdge — `.status-cell` from the prototype (cms-redesign-mockup.html
 * ~line 1132–1144). Renders the 22px first column of the Sessions list:
 * a 3px-wide vertical edge bar on the left of the row + a centered 8px dot.
 *
 * Replaces the more conventional StatusPill for list pages where status is
 * a row-wide signal (active = teal accent, inactive = red/danger accent).
 *
 *   <StatusEdge active />          // teal-green edge + teal dot with halo
 *   <StatusEdge active={false} />  // red (danger) edge + red dot with halo
 *
 * Usage: drop into the first <td> of each row. The <td> itself should set
 * `position: relative; width: 22px; padding: 0;` (matches `.status-cell`).
 */
import React from 'react';

export function StatusEdge({ active }) {
  //   active   edge/dot: teal-green + teal-soft halo
  //   inactive edge/dot: danger red (theme-aware) + red halo — a clear
  //   "off" signal that reads in both light and dark (Monday 12171352875).
  const edgeColor   = active ? 'rgb(var(--color-teal-green))' : 'rgb(var(--color-danger))';
  const edgeOpacity = active ? 1        : 0.9;
  const dotColor    = active ? 'rgb(var(--color-teal-green))' : 'rgb(var(--color-danger))';
  const dotHalo     = active ? '#75A29318' : 'rgb(var(--color-danger) / 0.2)';

  return (
    <>
      {/* `.edge` — 3px-wide bar pinned to the left edge, sm-radius on the
       *  right side only so it tucks into the row's start. */}
      <span
        aria-hidden
        style={{
          position: 'absolute',
          left: 0,
          top: 0,
          bottom: 0,
          width: 3,
          background: edgeColor,
          opacity: edgeOpacity,
          borderRadius: '0 4px 4px 0',
        }}
      />
      {/* `.dot` — 8px circle, vertically centered, soft 3px halo using the
       *  status color at low alpha. */}
      <span
        aria-hidden
        aria-label={active ? 'Active' : 'Inactive'}
        style={{
          position: 'absolute',
          left: 12,
          top: '50%',
          transform: 'translateY(-50%)',
          width: 8,
          height: 8,
          borderRadius: '50%',
          background: dotColor,
          boxShadow: `0 0 0 3px ${dotHalo}`,
        }}
      />
    </>
  );
}

export default StatusEdge;
